<template>
    <teleport to="body">
        <transition
            enter-active-class="transition ease-out duration-200"
            enter-from-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="transition ease-in duration-150"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
            <div
                v-if="visible"
                class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm"
                @click.self="$emit('close')"
            >
                <transition
                    enter-active-class="transition ease-out duration-200"
                    enter-from-class="opacity-0 scale-95 translate-y-2"
                    enter-to-class="opacity-100 scale-100 translate-y-0"
                    leave-active-class="transition ease-in duration-150"
                    leave-from-class="opacity-100 scale-100 translate-y-0"
                    leave-to-class="opacity-0 scale-95 translate-y-2"
                >
                    <div
                        v-if="visible"
                        class="w-full max-w-md bg-amber-50 border-2 border-amber-300 rounded-2xl shadow-2xl"
                        style="background: linear-gradient(135deg, #fef9c3 0%, #fef08a 100%);"
                    >
                        <div class="flex items-center justify-between px-5 pt-5 pb-3 border-b border-amber-300">
                            <div class="flex items-center gap-2">
                                <v-icon name="hi-solid-pencil-alt" class="w-5 h-5 text-amber-700" />
                                <h2 class="text-base font-bold text-amber-900">Nuovo Promemoria</h2>
                            </div>
                            <button
                                @click="$emit('close')"
                                class="text-amber-600 hover:text-amber-900 transition-colors"
                            >
                                <v-icon name="hi-x" class="w-5 h-5" />
                            </button>
                        </div>

                        <form @submit.prevent="submit" class="p-5 space-y-4">
                            <div>
                                <label class="block text-xs font-semibold text-amber-800 mb-1">
                                    Titolo <span class="text-rose-500">*</span>
                                </label>
                                <input
                                    v-model="form.title"
                                    type="text"
                                    maxlength="255"
                                    placeholder="Di cosa si tratta?"
                                    class="w-full rounded-xl border border-amber-300 bg-white/70 px-3 py-2 text-sm text-slate-800 placeholder-amber-400 focus:outline-none focus:ring-2 focus:ring-amber-400 focus:border-transparent"
                                    :class="{ 'border-rose-400 ring-1 ring-rose-400': errors.title }"
                                />
                                <p v-if="errors.title" class="text-xs text-rose-600 mt-1">{{ errors.title[0] }}</p>
                            </div>

                            <div>
                                <label class="block text-xs font-semibold text-amber-800 mb-1">
                                    Descrizione
                                </label>
                                <textarea
                                    v-model="form.description"
                                    rows="4"
                                    placeholder="Aggiungi dettagli…"
                                    class="w-full rounded-xl border border-amber-300 bg-white/70 px-3 py-2 text-sm text-slate-800 placeholder-amber-400 focus:outline-none focus:ring-2 focus:ring-amber-400 focus:border-transparent resize-none"
                                />
                            </div>
                            <div>
                                <v-select
                                    v-model="form.custSupp"
                                    class="w-full bg-white rounded-md focus:ring focus:ring-blue-200 focus:border-blue-500 p-2" 
                                    :options="customers"
                                    label="CompanyName"
                                    placeholder="Digita nome o codice cliente..."
                                    :clearable="true"
                                    :filter-by="(option, label, search) => {
                                    const q = search.toLowerCase();
                                    return (option.CompanyName || '').toLowerCase().includes(q)
                                        || (option.CustSupp || '').toLowerCase().includes(q);
                                    }"
                                >
                                    <template #option="option">
                                        <span class="font-medium">{{ option.CompanyName }}</span>
                                        <span class="text-gray-400 text-sm ml-2">({{ option.CustSupp }})</span>
                                    </template>
                                    <template #selected-option="option">
                                    <span>{{ option.CompanyName }} <span class="text-gray-400 text-sm">({{ option.CustSupp }})</span></span>
                                    </template>
                                    <template #no-options>
                                    Nessun cliente trovato.
                                    </template>
                                </v-select>
                            </div>
                            <div>
                                <label class="block text-xs font-semibold text-amber-800 mb-1">
                                    Assegna subito a un reparto
                                </label>
                                <select
                                    v-model="form.department_id"
                                    class="w-full rounded-xl border border-amber-300 bg-white/70 px-3 py-2 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-amber-400 focus:border-transparent"
                                >
                                    <option value="">Nessuno — vai in Inbox generale</option>
                                    <option v-for="dept in departments" :key="dept.id" :value="dept.id">
                                        {{ dept.name }}
                                    </option>
                                </select>
                            </div>

                            

                            <p v-if="errors.general" class="text-xs text-rose-600">{{ errors.general }}</p>

                            <div class="flex items-center justify-end gap-3 pt-1">
                                <button
                                    type="button"
                                    @click="$emit('close')"
                                    class="px-4 py-2 rounded-xl text-sm font-semibold text-amber-700 hover:bg-amber-100 transition-colors"
                                >
                                    Annulla
                                </button>
                                <button
                                    type="submit"
                                    :disabled="submitting || !form.title.trim()"
                                    class="inline-flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-semibold bg-amber-500 text-white hover:bg-amber-600 disabled:opacity-40 disabled:cursor-not-allowed transition-colors shadow-sm"
                                >
                                    <v-icon v-if="submitting" name="hi-solid-refresh" class="w-4 h-4 animate-spin" />
                                    <v-icon v-else name="hi-solid-check" class="w-4 h-4" />
                                    Salva promemoria
                                </button>
                            </div>
                        </form>
                    </div>
                </transition>
            </div>
        </transition>
    </teleport>
</template>

<script>
export default {
    name: 'CreateReminderModal',

    emits: ['close', 'created'],

    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        departments: {
            type: Array,
            default: () => [],
        },
        customers: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            submitting: false,
            errors: {},
            form: {
                title: '',
                description: '',
                department_id: '',
                custSupp: '',
            },
        };
    },

    watch: {
        visible(val) {
            if (val) {
                this.reset();
            }
        },
    },

    methods: {
        reset() {
            this.form = { title: '', description: '', department_id: '', custSupp: '' };
            this.errors = {};
            this.submitting = false;
        },

        submit() {
            if (!this.form.title.trim() || this.submitting) return;

            this.submitting = true;
            this.errors = {};

            const payload = {
                title:         this.form.title.trim(),
                description:   this.form.description.trim() || null,
                department_id: this.form.department_id || null,
                custSupp:      this.form.custSupp?.CustSupp || null,
            };

            axios.post(route('modules.attivita.promemoria.store'), payload)
                .then((response) => {
                    this.$emit('created', response.data?.reminder ?? null);
                    this.reset();
                })
                .catch((error) => {
                    if (error.response?.status === 422) {
                        this.errors = error.response.data.errors ?? {};
                        if (!Object.keys(this.errors).length) {
                            this.errors.general = error.response.data.message ?? 'Dati non validi.';
                        }
                    } else {
                        this.errors.general = 'Errore imprevisto. Riprova.';
                    }
                })
                .finally(() => {
                    this.submitting = false;
                });
        },
    },
};
</script>
